import { Button } from '@/components/ui/button'
import {
  Drawer,
  DrawerDetailRow,
  DrawerFooter,
  DrawerSection,
} from '@/components/ui/drawer'
import { SCORE_COLOR, getSatisfactionIcon } from '@/components/ui/feedback-bar'
import type { Feedback } from '@/types/api'
import { formatDateTime } from '@/utils/format'

interface FeedbackDetailDrawerProps {
  feedback: Feedback | null
  onClose: () => void
  showUnitColumn?: boolean
}

export function FeedbackDetailDrawer({
  feedback,
  onClose,
  showUnitColumn,
}: FeedbackDetailDrawerProps) {
  const source = (feedback ?? {}) as any
  const score = source.satisfactionScore as number | undefined
  const levelText =
    source.satisfactionLevel ?? (score !== undefined ? String(score) : '--')
  const createdAt = source.createdAt
    ? formatDateTime(new Date(source.createdAt))
    : '--'

  const audioUrl = source.audioRecordInfo?.fileUrl
  const noteText = source.description ?? ''

  return (
    <Drawer
      open={!!feedback}
      onClose={onClose}
      title="CHI TIẾT ĐÁNH GIÁ"
      size={760}
      styles={{ body: { overflow: 'auto' } }}
      footer={
        <DrawerFooter>
          <Button
            variant="outline"
            size="md"
            onClick={onClose}
            className="min-w-[160px] h-10"
          >
            Đóng
          </Button>
        </DrawerFooter>
      }
    >
      {feedback && (
        <div className="space-y-4">
          <DrawerSection title="Thông tin chung" bodyClassName="pb-3">
            <DrawerDetailRow label="Ngày thực hiện:" value={createdAt} />
            {showUnitColumn && (
              <DrawerDetailRow
                label="Đơn vị:"
                value={source.unitName || '--'}
              />
            )}
            <DrawerDetailRow label="Robot:" value={source.robotName || '--'} />
            <DrawerDetailRow
              label="Số điện thoại:"
              value={source.phoneNumber ?? ''}
            />
            <DrawerDetailRow
              label="Số thứ tự xếp hàng:"
              value={source.receptionNumber ?? ''}
            />
            <DrawerDetailRow
              label="Đánh giá:"
              value={
                <span
                  className={`inline-flex items-center gap-1.5 ${score ? SCORE_COLOR[score] : 'text-gray-700'}`}
                >
                  {score ? getSatisfactionIcon(score) : null}
                  <span>{levelText}</span>
                </span>
              }
            />
            <DrawerDetailRow
              label="Loại phản ánh:"
              value={source.surveyTypeName ?? source.problemNote ?? ''}
            />
          </DrawerSection>

          <DrawerSection title="Ghi âm" bodyClassName="pb-4">
            {audioUrl ? (
              <audio
                controls
                src={audioUrl}
                className="w-full"
                preload="metadata"
              >
                <track kind="captions" label="Phụ đề" />
              </audio>
            ) : (
              <div className="text-sm text-gray-500">Không có tệp ghi âm</div>
            )}

            <div className="mt-3 rounded-xl border border-gray-300 bg-white p-3 text-sm text-gray-700">
              {noteText}
            </div>
          </DrawerSection>
        </div>
      )}
    </Drawer>
  )
}
